import React from 'react';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { TableBase, WrapperDivsTables } from './style';

export default function CalculoDoFluxoDeCaixa() {
  return (
    <main>
      <WrapperDivsTables>
        <TableBase>
          <thead>
            <tr>
              <th colSpan="2" className="NoBorder">
                Realização: 100%
              </th>
              <th colSpan="13" className="LightBlue">
                Mês excluído da Execução e/ou do Fluxo de Caixa do Projeto?
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="2" className="NoBorder"></td>
              <td className="LightBlue">
                <SelectAndOptions id="MesExcluidoDaExecucao1" optionsArray={['Não', 'Sim']} widthPercentage="100%" />
              </td>
              <td className="LightBlue">
                <SelectAndOptions id="MesExcluidoDaExecucao1" optionsArray={['Não', 'Sim']} widthPercentage="100%" />
              </td>
              <td className="LightBlue">
                <SelectAndOptions id="MesExcluidoDaExecucao1" optionsArray={['Não', 'Sim']} widthPercentage="100%" />
              </td>
              <td className="LightBlue">
                <SelectAndOptions id="MesExcluidoDaExecucao1" optionsArray={['Não', 'Sim']} widthPercentage="100%" />
              </td>
              <td className="LightBlue">
                <SelectAndOptions id="MesExcluidoDaExecucao1" optionsArray={['Não', 'Sim']} widthPercentage="100%" />
              </td>
              <td className="LightBlue">
                <SelectAndOptions id="MesExcluidoDaExecucao1" optionsArray={['Não', 'Sim']} widthPercentage="100%" />
              </td>
              <td className="LightBlue">
                <SelectAndOptions id="MesExcluidoDaExecucao1" optionsArray={['Não', 'Sim']} widthPercentage="100%" />
              </td>
              <td className="LightBlue">
                <SelectAndOptions id="MesExcluidoDaExecucao1" optionsArray={['Não', 'Sim']} widthPercentage="100%" />
              </td>
              <td className="LightBlue">
                <SelectAndOptions id="MesExcluidoDaExecucao1" optionsArray={['Não', 'Sim']} widthPercentage="100%" />
              </td>
              <td className="LightBlue">
                <SelectAndOptions id="MesExcluidoDaExecucao1" optionsArray={['Não', 'Sim']} widthPercentage="100%" />
              </td>
              <td className="LightBlue">
                <SelectAndOptions id="MesExcluidoDaExecucao1" optionsArray={['Não', 'Sim']} widthPercentage="100%" />
              </td>
              <td className="LightBlue">
                <SelectAndOptions id="MesExcluidoDaExecucao1" optionsArray={['Não', 'Sim']} widthPercentage="100%" />
              </td>
              <td className="LightBlue">
                <SelectAndOptions id="MesExcluidoDaExecucao1" optionsArray={['Não', 'Sim']} widthPercentage="100%" />
              </td>
            </tr>
            <tr>
              <td colSpan="1" className="NoBorder"></td>
            </tr>
            <tr>
              <th colSpan="2" className="Blue">
                Realizado: Julho
              </th>
              <th className="Gray">ago/21</th>
              <th className="Gray">set/21</th>
              <th className="Gray">out/21</th>
              <th className="Gray">nov/21</th>
              <th className="Gray">dez/21</th>
              <th className="Gray">jan/21</th>
              <th className="Gray">fev/21</th>
              <th className="Gray">mar/21</th>
              <th className="Gray">abr/21</th>
              <th className="Gray">mai/21</th>
              <th className="Gray">jun/21</th>
              <th className="Gray">jul/21</th>
              <th className="Gray">outros</th>
              <th className="Gray">Total a Incorrer</th>
              <th className="Gray">Total Geral</th>
            </tr>
            <tr>
              <td colSpan="17" className="NoBorder"></td>
            </tr>
            <tr>
              <td className="NoBorder">FATURAMENTO LÍQUIDO (R$)</td>
              <td className="NoBorder">
                <input type="text" />
              </td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Gray">0</td>
              <td className="Gray">0</td>
            </tr>
            <tr>
              <td className="NoBorder">FATURAMENTO BRUTO (R$)</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Gray">0</td>
              <td className="Gray">0</td>
            </tr>
            <tr>
              <td colSpan="17" className="NoBorder"></td>
            </tr>
            <tr>
              <td className="NoBorder">CUSTO com Pessoal (TAXA CHEIA) (R$)</td>
              <td className="NoBorder">
                <input type="text" />
              </td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Gray">0</td>
              <td className="Gray">0</td>
            </tr>
            <tr>
              <td className="NoBorder">CUSTO com Pessoal AJUSTADO (R$)</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Gray">0</td>
              <td className="Gray">0</td>
            </tr>
            <tr>
              <td className="NoBorder">OUTROS GASTOS (R$)</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Gray">0</td>
              <td className="Gray">0</td>
            </tr>
            <tr>
              <td colSpan="12" className="NoBorder"></td>
              <td colSpan="3" className="NoBorder">
                TOTAL DOS GASTOS:
              </td>
              <td className="Gray">0</td>
              <td className="Gray">0</td>
            </tr>
            <tr>
              <td colSpan="17" className="NoBorder"></td>
            </tr>
            <tr>
              <td className="NoBorder">Custos com TERCEIROS</td>
              <td className="NoBorder">
                <input type="text" />
              </td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Gray">0</td>
              <td className="Gray">0</td>
            </tr>
            <tr>
              <td className="NoBorder">Outros Custos Diretos</td>
              <td className="NoBorder">
                <input type="text" />
              </td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Gray">0</td>
              <td className="Gray">0</td>
            </tr>
            <tr>
              <td className="NoBorder">Despesas Variáveis</td>
              <td className="NoBorder">
                <input type="text" />
              </td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Gray">0</td>
              <td className="Gray">0</td>
            </tr>
            <tr>
              <td className="NoBorder">Investimentos</td>
              <td className="NoBorder">
                <input type="text" />
              </td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Gray">0</td>
              <td className="Gray">0</td>
            </tr>
            <tr>
              <td colSpan="17" className="NoBorder"></td>
            </tr>
            <tr>
              <td colSpan="2" className="NoBorder">
                WIP ANTES DOS JUROS (R$)
              </td>
              <td className="Yellow">-</td>
              <td className="Yellow">-</td>
              <td className="Yellow">-</td>
              <td className="Yellow">-</td>
              <td className="Yellow">-</td>
              <td className="Yellow">-</td>
              <td className="Yellow">-</td>
              <td className="Yellow">-</td>
              <td className="Yellow">-</td>
              <td className="Yellow">-</td>
              <td className="Yellow">-</td>
              <td className="Yellow">-</td>
              <td className="Yellow">-</td>
              <td colSpan="2" className="NoBorder"></td>
            </tr>
            <tr>
              <td className="NoBorder">Juros (R$)</td>
              <td className="NoBorder">
                <input type="text" />
              </td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Gray">0</td>
              <td className="Gray">0</td>
            </tr>
            <tr>
              <td colSpan="17" className="NoBorder"></td>
            </tr>
            <tr>
              <td className="NoBorder">AJUSTE PLANEJADO (R$)</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Gray">0</td>
              <td className="Gray">0</td>
            </tr>
            <tr>
              <td colSpan="1" className="NoBorder"></td>
            </tr>
            <tr>
              <td className="NoBorder">WIP CALCULADO (R$)</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td colSpan="2"></td>
            </tr>
            <tr>
              <td colSpan="1" className="NoBorder"></td>
            </tr>
            <tr>
              <td className="NoBorder">Work In Process (WIP) FINAL PREVISTO (R$)</td>
              <td className="Green">-</td>
              <td colSpan="15" className="NoBorder">
                Quando o WIP está positivo, significa que os GASTOS são maiores que as RECEITAS e assim serão carregados
                juros contra o projeto.
              </td>
            </tr>
            <tr>
              <td colSpan="17" className="NoBorder"></td>
            </tr>
            <tr>
              <td className="NoBorder">Horas</td>
              <td className="NoBorder">
                <input type="text" />
              </td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Gray">0</td>
              <td className="Gray">0</td>
            </tr>
            <tr>
              <td className="NoBorder">Taxa Média</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Green">-</td>
              <td className="Gray">0</td>
              <td className="Gray">0</td>
            </tr>
          </tbody>
        </TableBase>
      </WrapperDivsTables>
    </main>
  );
}
